var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_list_content"},_vm._l((this.$store.state.listUsersOnPoint),function(data){return _c('UserRow',{key:data.userID,attrs:{"user":data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }